module.exports = [
  {
    title: 'Visible',
    description: 'Should a host be visible in this game site',
    name: 'visible',
    type: 'boolean',
  },
  {
    title: 'Content',
    description: 'Host page main content',
    name: 'content',
    type: 'blockContent',
  },
  {
    title: 'Landing Page',
    description:
      'If the host has a dedicated landing page for the game put it here. e.g. https://www.survivalservers.com/services/game_servers/ark_survival_evolved/',
    name: 'landingPageUrl',
    type: 'url',
  },
  {
    title: 'Order Page URL',
    description:
      "The URL on the 'Add to cart' button. Note: check the url on the actual button, not the url in the address bar after clicking it",
    name: 'orderUrl',
    type: 'url',
  },
  {
    title: 'Affiliate Url',
    name: 'affiliateUrl',
    description: 'Affiliate url for this specific game',
    type: 'url',
  },
  {
    title: 'Locations',
    description:
      'All the locations where you can host an this game. Leave empty if the same as above locations. Overwrites the above locations.',
    name: 'locations',
    type: 'array',
    of: [{ type: 'location' }],
  },
  {
    title: 'Slots',
    name: 'slots',
    type: 'object',
    fields: [
      {
        title: 'Minimum',
        name: 'min',
        description:
          'The smallest amount of slots available with this host for this game',
        type: 'number',
        validation: Rule => Rule.required().max(Rule.valueOfField('max')),
      },
      {
        title: 'Maximum',
        name: 'max',
        description:
          'The biggest amount of slots available with this host for this game',
        type: 'number',
        validation: Rule => Rule.required().min(Rule.valueOfField('min')),
      },
    ],
  },
  {
    title: 'Prices',
    name: 'price',
    type: 'object',
    fields: [
      {
        title: 'Minimum',
        name: 'min',
        type: 'number',
        description: 'The minimum price per slot',
        // validation: Rule => Rule.required().max(Rule.valueOfField('max')),
      },
      {
        title: 'Maximum',
        name: 'max',
        type: 'number',
        description:
          'The maximum price per slot. If the price per slot is the same across all number of slots, use the same value as minimum',
        // validation: Rule => Rule.required().min(Rule.valueOfField('min')),
      },
    ],
  },
  {
    title: 'Example packages',
    type: 'array',
    name: 'packages',
    of: [
      {
        type: 'object',
        fields: [
          {
            title: 'Slots',
            type: 'number',
            name: 'slots',
          },
          {
            title: 'Price',
            description: 'Price per slot',
            type: 'number',
            name: 'price',
          },
          {
            title: 'Total',
            description: 'Total price for package',
            type: 'number',
            name: 'total',
          },
          {
            title: 'Location',
            type: 'string',
            name: 'location',
          },
        ],
        preview: {
          select: {
            slots: 'slots',
            price: 'price',
            location: 'location',
            total: 'total',
          },
          prepare: ({ slots, price, location, total }) => ({
            title: `${slots} Slots | ${price}/slot  |  ${total ||
              price * slots}/mo  |  ${location}`,
          }),
        },
      },
    ],
  },
  {
    title: 'Control Panel',
    name: 'controlPanel',
    type: 'object',
    fields: [
      {
        title: 'Type',
        name: 'type',
        type: 'string',
        description: 'What type of control panel is it?',
        options: {
          list: [
            { title: 'TCAdmin', value: 'tcadmin' },
            { title: 'Custom', value: 'custom' },
          ],
        },
      },
      {
        title: 'Screenshots',
        name: 'screenshots',
        type: 'array',
        description:
          'Try to find images of the control panel. Ask via customer support channel for examples',
        of: [
          {
            type: 'image',
            fields: [
              {
                name: 'caption',
                type: 'string',
                title: 'Caption',
                options: {
                  isHighlighted: true, // <-- make this field easily accessible
                },
              },
            ],
          },
        ],
      },
    ],
  },
  {
    title: 'Platforms',
    name: 'platforms',
    type: 'array',
    of: [{ type: 'string' }],
    description:
      "Which platforms does this host support for this game? Note: Check that you can actually order now and it's not pre-order",
    options: {
      list: [
        {
          title: 'PC',
          value: 'pc',
        },
        {
          title: 'PS4',
          value: 'playstation',
        },
        {
          title: 'Xbox',
          value: 'xbox',
        },
      ],
    },
  },
  {
    title: 'Mods Support',
    name: 'mods',
    type: 'object',
    fields: [
      {
        title: 'Supported',
        name: 'supported',
        type: 'boolean',
        description: 'Can you install mods with this host',
      },
      {
        title: 'Mod Manager GUI',
        name: 'modManager',
        type: 'boolean',
        description:
          'Does this host have a custom point and click mod manager gui? or is it though INI?',
      },
      {
        title: 'Auto Updated',
        name: 'autoUpdate',
        type: 'boolean',
        description: 'Does this host have auto updating mods',
      },
      {
        title: '1-Click Install',
        name: 'oneclick',
        type: 'boolean',
        description: 'Does the host have a 1-click mod install feature?',
      },
      {
        title: 'Other notes',
        name: 'notes',
        type: 'text',
        description:
          'Please specify other things you think are worth mentitiong.',
      },
    ],
  },
  {
    title: 'Pros',
    name: 'pros',
    type: 'array',
    of: [{ type: 'string' }],
  },
  {
    title: 'Cons',
    name: 'cons',
    type: 'array',
    of: [{ type: 'string' }],
  },
  {
    title: 'Notes',
    name: 'notes',
    type: 'array',
    of: [{ type: 'string' }],
  },
]



// WEBPACK FOOTER //
// /opt/build/repo/sanity/schemas/games/baseGameFields.js